 <div style="width: 90%; margin: 2% 5%">
  <div class="table-header">
    <span class="medium-border-arma-color table-title-fit-content-no-margin table-certificate-title">
      {{ 'Suivi chantier' | translate }} <br> {{toolbarSelectedSiteCode}}
    </span>

    <mat-form-field style="min-width: 350px;">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [(ngModel)]="mTableFilter.globalFilter" (keyup)="filterOrder()" [placeholder]="'Rechercher' | translate">
    </mat-form-field>

    <div class="header-button-row">

      <button mat-raised-button [matMenuTriggerFor]="menuParameter">
        <mat-icon aria-hidden="false" aria-label="settings">settings</mat-icon>
        <label>{{'Paramètres' | translate}}</label>
      </button>

      <button mat-button (click)="downloadAllDeco()">
        {{ 'Télécharger tout' | translate }}
      </button>

    </div>
  </div>

  <table #matTableListDeco
         style="max-width: 100%; margin: auto"
         mat-table
         [dataSource]="HTML_TableDataSource"
         matSort
         [matSortActive]="CST_MAT_COLUMN_CreationDate"
         matSortDirection="desc"
         matSortDisableClear
         class="mat-elevation-z8 medium-border-arma-color cmat-add-border no-table-padding"
         id="table">

    <!-- OrderCode or JoiningCode -->
    <ng-container [matColumnDef]="CST_MAT_COLUMN_OrderCode">
        <th mat-header-cell
            *matHeaderCellDef
            [mat-sort-header]="asKeyOfTableData('JoiningCode')"
            class="cmat-center-btn">
          {{'Code contrat' | translate}}
          <app-filter-component [columnFilterCheck]="mTableFilter.getColumnFilterChecklist(CST_MAT_COLUMN_OrderCode)"
                                (onChange)="filterOrder()"></app-filter-component>
        </th>
        <td mat-cell *matCellDef="let element">
          <div *ngIf="mUseJoiningCode; then thenJoiningCode else elseJoiningCode"></div>
          <ng-template #thenJoiningCode>{{asTableData(element).JoiningCode | onlyNumSupZero}}</ng-template>
          <ng-template #elseJoiningCode>{{asTableData(element).Code}}</ng-template>
        </td>
    </ng-container>

    <ng-container [matColumnDef]="CST_MAT_COLUMN_EXT_ORDER_CODE">
      <th mat-header-cell
          *matHeaderCellDef
          [mat-sort-header]="asKeyOfTableData('extCode')"
          class="cmat-center-btn">
        {{'Code externe' | translate}}
        <app-filter-component [columnFilterCheck]="mTableFilter.getColumnFilterChecklist(CST_MAT_COLUMN_EXT_ORDER_CODE)"
                              (onChange)="filterOrder()"></app-filter-component>
      </th>
      <td mat-cell *matCellDef="let element">{{asTableData(element).extCode}}</td>
    </ng-container>

    <!-- CreationDate       -->
    <ng-container [matColumnDef]="CST_MAT_COLUMN_CreationDate">
        <th class="cmat-center-btn" mat-header-cell *matHeaderCellDef [mat-sort-header]="asKeyOfTableData('UnixCreationDate')" start="desc">
          {{'Date de création' | translate}}
          <app-filter-component [columnFilterDate]="mTableFilter.getColumnFilterDate(CST_MAT_COLUMN_CreationDate)"
                                (onChange)="filterOrder()"></app-filter-component>
        </th>
        <td mat-cell *matCellDef="let element">{{asTableData(element).CreationDate}}</td>
    </ng-container>

    <ng-container [matColumnDef]="CST_MAT_COLUMN_CUSTOMER_REF">
      <th mat-header-cell *matHeaderCellDef="let element">{{'Référence client' | translate}}</th>
      <td mat-cell *matCellDef="let element">{{asTableData(element).CustomerRef}}</td>
    </ng-container>

    <!-- Drawing            -->
    <ng-container [matColumnDef]="CST_MAT_COLUMN_Drawing">
        <th class="cmat-center-btn" mat-header-cell *matHeaderCellDef [mat-sort-header]="asKeyOfTableData('Drawing')"> {{'Plan' | translate}} </th>
        <td mat-cell *matCellDef="let element">{{asTableData(element).Drawing}}</td>
    </ng-container>

    <!-- Weight: string     -->
    <ng-container [matColumnDef]="CST_MAT_COLUMN_Weight">
        <th mat-header-cell
            *matHeaderCellDef
            [mat-sort-header]="asKeyOfTableData('Weight')"
            class="cmat-center-btn"
            style="width: 120px;"> {{'Poids' | translate}} (kg) </th>
        <td mat-cell *matCellDef="let element">
            <div class="table-price-right">
                {{asTableData(element).Weight | onlyNumSupZero | number: '1.0-0'}}
            </div>
        </td>
    </ng-container>

    <!-- Production status -->
    <ng-container [matColumnDef]="CST_MAT_COLUMN_Production">
        <th mat-header-cell
            *matHeaderCellDef
            [mat-sort-header]="asKeyOfTableData('ProductionStatusStr')"
            class="cmat-center-btn">
          {{'Etat de production' | translate}}
          <app-filter-component [columnFilterCheck]="mTableFilter.getColumnFilterChecklist(CST_MAT_COLUMN_Production)"
                                (onChange)="filterOrder()"></app-filter-component>
        </th>
        <td mat-cell *matCellDef="let element">
          <div [matTooltip]="asTableData(element).ProductionStatusDescription | translate">
            {{asTableData(element).ProductionStatusStr}}
          </div>
        </td>
    </ng-container>

    <!-- Delivery status -->
    <ng-container [matColumnDef]="CST_MAT_COLUMN_Delivery">
        <th mat-header-cell *matHeaderCellDef>
          {{'Etat livraison' | translate}}
          <app-filter-component [columnFilterCheck]="mTableFilter.getColumnFilterChecklist(CST_MAT_COLUMN_Delivery)"
                                (onChange)="filterOrder()"></app-filter-component>
        </th>
        <td mat-cell *matCellDef="let element">
          <div [matTooltip]="asTableData(element).DeliveryStatusDescription">
            {{asTableData(element).DeliveryStatusStr}}
          </div>
        </td>
    </ng-container>

    <!-- PersonInCharge: string,    -->
    <ng-container [matColumnDef]="CST_MAT_COLUMN_PersonInCharge">
        <th mat-header-cell
            *matHeaderCellDef
            [mat-sort-header]="asKeyOfTableData('PersonInCharge')"
            class="cmat-center-btn">
          {{'Personne en charge' | translate}}
          <app-filter-component [columnFilterCheck]="mTableFilter.getColumnFilterChecklist(CST_MAT_COLUMN_PersonInCharge)"
                                (onChange)="filterOrder()"></app-filter-component>
        </th>
        <td mat-cell *matCellDef="let element">{{asTableData(element).PersonInCharge}}</td>
    </ng-container>

    <!-- PlannedDelivDate: string,  -->
    <ng-container [matColumnDef]="CST_MAT_COLUMN_PlannedDelivDate">
        <th mat-header-cell
            *matHeaderCellDef
            [mat-sort-header]="asKeyOfTableData('PlannedDeliveryDate')"
            class="cmat-center-btn"> {{'Date de livraison' | translate}} </th>
        <td mat-cell *matCellDef="let element">{{asTableData(element).PlannedDeliveryDate}}</td>
    </ng-container>

    <!-- Action -->
    <ng-container [matColumnDef]="CST_MAT_COLUMN_Action">
      <th style="width: 1px;" mat-header-cell *matHeaderCellDef> {{'Action' | translate}} </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="asTableData(element).Source == 'Order'">
          <button
            style="margin: 0 1px;"
            mat-stroked-button
            (click)="showOrder(element)"
            matTooltip="{{'Consulter' | translate}}">
            <img height="24px" alt="view" src="assets/icons/view.png">
          </button>
          <button
            style="margin: 0 1px;"
            mat-stroked-button
            (click)="showOrder(element, true)"
            matTooltip="{{'Télécharger' | translate}}">
            <img height="24px" alt="download" src="assets/icons/download.png">
          </button>
        </ng-container>
      </td>
    </ng-container>

    <!-- Information complementaire -->
    <ng-container *ngFor="let infoComp of HTML_ArrayInfoCompName">
      <ng-container matColumnDef="{{infoComp}}">
        <th mat-header-cell *matHeaderCellDef class="complementary-info-col">{{infoComp}}</th>
        <td mat-cell *matCellDef="let element">
          {{asTableData(element).infoComp[infoComp]}}
        </td>
      </ng-container>
    </ng-container>

    <tr mat-header-row
        class="header-centered armaor-background-color tr-header"
        *matHeaderRowDef="HTML_TableaHeader;
        sticky: true">
    </tr>
    <tr mat-row *matRowDef="let row; columns: HTML_TableaHeader;" class="hover-table-smoke"></tr>
  </table>

  <mat-paginator #TablePaginator [pageSize]="50" showFirstLastButtons class="center-content sticky-paginator"></mat-paginator>
</div>

<mat-menu #menuParameter>

  <div (click)="$event.stopPropagation()">

    <mat-checkbox *ngIf="mHasExtOrderCode"
                  [(ngModel)]="visibilityColumn.displayExtOrderCode"
                  (change)="updateTableHeader(true)"
                  class="mat-menu-item">
      {{'Afficher le code externe' | translate}}
    </mat-checkbox>

    <mat-checkbox [(ngModel)]="visibilityColumn.displayCreationDate"
                  (change)="updateTableHeader(true)"
                  class="mat-menu-item">
      {{'Afficher la date de création' | translate}}
    </mat-checkbox>

    <mat-checkbox [(ngModel)]="visibilityColumn.displayCustomerRef"
                  (change)="updateTableHeader(true)"
                  class="mat-menu-item">
      {{'Afficher la référence du client' | translate}}
    </mat-checkbox>

    <mat-checkbox [(ngModel)]="visibilityColumn.displayDrawing"
                  (change)="updateTableHeader(true)"
                  class="mat-menu-item">
      {{'Afficher plan' | translate}}
    </mat-checkbox>

    <mat-checkbox [(ngModel)]="visibilityColumn.displayWeight"
                  (change)="updateTableHeader(true)"
                  class="mat-menu-item">
      {{'Afficher le poids' | translate}}
    </mat-checkbox>

    <mat-checkbox [(ngModel)]="visibilityColumn.displayProduction"
                  (change)="updateTableHeader(true)"
                  class="mat-menu-item">
      {{'Afficher l\'état de la production' | translate}}
    </mat-checkbox>

    <mat-checkbox [(ngModel)]="visibilityColumn.displayDelivery"
                  (change)="updateTableHeader(true)"
                  class="mat-menu-item">
      {{'Afficher l\'état de livraison' | translate}}
    </mat-checkbox>

    <mat-checkbox [(ngModel)]="visibilityColumn.displayPersonInCharge"
                  (change)="updateTableHeader(true)"
                  class="mat-menu-item">
      {{'Afficher le responsable' | translate}}
    </mat-checkbox>

    <mat-checkbox [(ngModel)]="visibilityColumn.displayPlannedDelivDate"
                  (change)="updateTableHeader(true)"
                  class="mat-menu-item">
      {{'Afficher la date de livraison' | translate}}
    </mat-checkbox>

    <mat-checkbox *ngIf="HTML_ArrayInfoCompName.length > 0"
                  [(ngModel)]="visibilityColumn.displayInfoComp"
                  (change)="updateTableHeader(true)"
                  class="mat-menu-item">
      {{'Afficher' | translate}}
      {{HTML_ArrayInfoCompName.toString()}}
    </mat-checkbox>

  </div>

</mat-menu>
